import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import VuetifySnackbarQueue from 'vuetify-snackbar-queue'

Vue.use(Vuetify)
Vue.use(VuetifySnackbarQueue)

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        primary: '#000e38',
        secondary: '#1f49bd',
      },
    },
  },
})
